import { render, staticRenderFns } from "./SalesDeliveryListTable.vue?vue&type=template&id=63dd57bb"
import script from "./SalesDeliveryListTable.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports